/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from 'react';
import { Form, Select, Checkbox, DatePicker } from 'antd';
import moment from 'moment';

const layout = {
  labelCol: { span: 24 },
};

const GetField = Component =>
  React.forwardRef(
    ({ meta, children, hasFeedback, style, label, ...rest }, ref) => {
      const hasError = meta && meta.touched && meta.invalid;

      if (Component === DatePicker) {
        rest.value = rest.value ? moment(new Date(rest.value)) : null;
      }

      if (Component === Select) {
        rest.showSearch =
          rest.showSearch || (rest ? rest.showSearch : null) || true;
        rest.optionFilterProp =
          rest.optionFilterProp ||
          (rest ? rest.optionFilterProp : 'children') ||
          'children';
        delete rest.onBlur;
      }

      if (Component === Checkbox) {
        rest.checked = !!rest.value;
        delete rest.value;
      }

      return (
        <Form.Item
          {...layout}
          label={label}
          validateStatus={hasError ? 'error' : 'success'}
          hasFeedback={hasFeedback && hasError}
          help={hasError && meta.error}
          style={style}
        >
          <Component className="input" {...rest} ref={ref} step="any">
            {children}
          </Component>
        </Form.Item>
      );
    }
  );

export default GetField;
